import { Button, Divider, Skeleton, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import HorizontalVideoCellSkeleton from "../components/Skeletons/HorizontalVideoCellSkeleton";
// import VideoGroup from "../components/VideoGroup";
// import VideoPlayer from "../components/VideoPlayer";
import VideoThumbnailHorizontal from "../components/VideoThumbnailHorizontal";
import { subscribe } from "../config/axios";
import useAuth from "../hooks/useAuth";
import useAxios from "../hooks/useAxios";
import { FaShare, FaStar } from "react-icons/fa";
import Dialog from "../components/Dialog/Dialog";
import RatingDialog from "../components/Dialog/RatingDialog";
import ShareDialog from "../components/Dialog/ShareDialog";
// import Comments from "../components/Comments";

export default function Video() {
  const [url, setUrl] = useState();
  const [title, setTitle] = useState();
  const [categoryArray, setCategoryArray] = useState([]);
  const [catTitle, setCatTitle] = useState();
  // const [loading, setLoading] = useState(false);
  const axios = useAxios();
  const { pathname } = useLocation();
  const pathnameArr = pathname.split("/");
  const videoId = pathnameArr[4];
  const categoryId = pathnameArr[2];
  const [vidId, setVidId] = useState(videoId);
  const [catId, setCatId] = useState(categoryId);
  // const { token } = useAuth();
  const navigate = useNavigate();

  useEffect(
    () => {
      if (vidId !== videoId || catId !== categoryId) {
        window.location.reload();
        setCatId(categoryId);
        setVidId(videoId);
      }
    },
    [categoryId, catId, videoId, vidId],
    vidId
  );

  useEffect(() => {
    const fetchVideo = async () => {
      // setLoading(true);
      try {
        const response = await axios.get(
          "category/" + categoryId + "/content/" + videoId
        );
        // console.log(response);
        setUrl(response.data.url);
        setTitle(response.data.title);
      } catch (error) {
        if (+error.response.status === 401) {
          toast.error("ستتم إعادة توجيهك إلى صفحة زين للمتابعة", {
            toastId: "redirect",
          });
          window.location.replace(subscribe);
          setUrl("https://www.youtube.com/watch?v=j-dMNJ5N3MU");
          setTitle("إعادة توجيهك إلى صفحة زين");
        }
      }
      // setLoading(false);
    };
    fetchVideo();
  }, [categoryId, axios, videoId, navigate]);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(`recommend/${videoId}?limit=10`);
        setCategoryArray(response.data);
        setCatTitle("مقترح لك");
        // setVideoArray(response.data.data);
      } catch (error) {}
    };
    fetchVideos();
  }, [categoryId, axios, videoId]);

  const videoThumbs = categoryArray?.map((video) => {
    return (
      <VideoThumbnailHorizontal
        key={Math.random()}
        src={video?.thumbnail}
        duration={video?.details?.duration}
        title={video?.title?.ar}
        videoId={video?.id}
        catagoryId={video?.category_id}
        categoryTitle={catTitle}
        rating={video?.rate}
      />
    );
  });

  return (
    <Stack
      flexDirection={{ xs: "column", lg: "row" }}
      alignItems={{ xs: "flex-start", lg: "flex-start" }}
      width="100%"
      gap={2}
      mt={{ lg: 3 }}
    >
      <Stack flexDirection="column" minWidth={{ xs: "100%", lg: "60%" }}>
        {url ? (
          <video
            controls
            autoPlay
            name="media"
            width="100%"
            height="auto"
            onContextMenu={(e) => e.preventDefault()}
            controlsList={["nodownload"]}
          >
            <source src={url} type="video/mp4" />
          </video>
        ) : (
          <Skeleton
            variant="rectangular"
            width="100%"
            sx={{ transform: "none", height: { xs: "200px", md: "400px" } }}
          />
        )}

        {title ? (
          <Typography
            variant="h5"
            sx={{ alignSelf: "flex-start", mx: 2, mt: 2 }}
          >
            {title}
          </Typography>
        ) : (
          <Skeleton
            width={150}
            height={20}
            sx={{ alignSelf: "flex-start", mx: 2, mt: 2 }}
          />
        )}
        <VideoActions />

        {/* <Divider sx={{ my: 2 }} />
        <Comments /> */}
      </Stack>

      <Divider sx={{ width: { xs: "100%", lg: "auto" } }} />

      <Stack flexDirection="column" width="90%" gap={1.5} mb={2} pl={2}>
        {videoThumbs?.length > 0 ? (
          <>
            <Typography variant="h4" fontSize="1.2rem" mb={1}>
              {catTitle}
            </Typography>
            {videoThumbs}
          </>
        ) : (
          <>
            <Skeleton
              width={150}
              height={25}
              sx={{ alignSelf: "flex-start", my: 1 }}
            />
            {[...Array(5)].map(() => (
              <HorizontalVideoCellSkeleton key={Math.random()} />
            ))}
          </>
        )}
      </Stack>
    </Stack>
  );
}

function VideoActions() {
  return (
    <Stack flexDirection="row" gap={1} mx={2} mt={3} mb={1}>
      <Dialog
        title="تقيم الفيديو الحالي"
        openElement={
          <Button
            startIcon={<FaStar size={15} />}
            variant="contained"
            color="lightgrey"
            sx={{ borderRadius: 5 }}
          >
            تقيم
          </Button>
        }
      >
        <RatingDialog />
      </Dialog>

      <Dialog
        title="شارك هذا الفيديو"
        openElement={
          <Button
            startIcon={<FaShare size={15} />}
            variant="contained"
            color="lightgrey"
            sx={{ borderRadius: 5 }}
          >
            <span>مشاركة</span>
          </Button>
        }
      >
        <ShareDialog />
      </Dialog>
    </Stack>
  );
}
